import { TrendingUp } from 'lucide-react';
import { useNavigationStore } from '../../stores/navigationStore';
import { Link } from 'react-router-dom';

interface NavItem {
  id: string;
  name: string;
  icon: React.ElementType;
  path: string;
}

interface NavigationMostUsedProps {
  allNavItems: NavItem[];
  limit?: number;
}

export function NavigationMostUsed({ allNavItems, limit = 5 }: NavigationMostUsedProps) {
  const { getMostUsed, incrementUsage, density } = useNavigationStore();

  const mostUsedIds = getMostUsed(limit);
  const mostUsedItems = allNavItems.filter((item) => mostUsedIds.includes(item.id));

  if (mostUsedItems.length === 0) {
    return null;
  }

  const paddingClass = {
    compact: 'py-1.5 px-2',
    normal: 'py-2 px-3',
    comfortable: 'py-2.5 px-3',
  }[density];

  const spacingClass = {
    compact: 'space-y-0.5',
    normal: 'space-y-1',
    comfortable: 'space-y-1.5',
  }[density];

  return (
    <div className={spacingClass}>
      <div className="px-3 py-2 flex items-center space-x-2">
        <TrendingUp className="w-3.5 h-3.5 text-gray-500" />
        <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
          Most Used
        </span>
      </div>
      <div className={spacingClass}>
        {mostUsedItems.map((item, index) => {
          const Icon = item.icon;
          return (
            <Link
              key={item.id}
              to={item.path}
              onClick={() => incrementUsage(item.id)}
              className={`w-full flex items-center space-x-2 ${paddingClass} text-sm text-gray-700 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition group`}
            >
              <span className="text-xs font-semibold text-gray-400 w-4">#{index + 1}</span>
              <Icon className="w-4 h-4 text-orange-500" />
              <span className="flex-1 text-left truncate">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}




























